import { render, staticRenderFns } from "./view-business-driver-link.vue?vue&type=template&id=141e65b8&"
import script from "./view-business-driver-link.vue?vue&type=script&lang=js&"
export * from "./view-business-driver-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports